<template>
  <v-app>
    <template v-if="loading === true">
      <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="light-green darken-4"
        height="10"></v-progress-linear>
    </template>
    <v-container>
      <v-row>
        <v-col cols="auto">
          <date-picker placeholder="Дата заключения" valueType="format" clearable v-model:value="time0"
            confirm-text="Выбрать даты" range></date-picker>
        </v-col>
        <!-- date picker 56px -->
        <v-col cols="2">
          <v-autocomplete variant="outlined" :items="experts" v-model="selectExperts" clearable closable-chips chips
            multiple item-value="id" item-title="name" label="Эксперт">
          </v-autocomplete>
        </v-col>
        <!-- <v-col cols="2">
          <v-autocomplete :items="products" item-value="id" item-title="name" variant="outlined" label="Товар">
          </v-autocomplete>
        </v-col> -->
        <v-col cols="2">
          <v-autocomplete variant="outlined" :items="category" v-model="selectCategry" clearable closable-chips chips
            multiple item-value="id" item-title="name" label="Воронка">
          </v-autocomplete>
        </v-col>
        <v-col cols="auto">
          <v-btn size="x-large" variant="outlined" @click="goInvoice"> Сформировать
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn class="bg-blue-1" size="x-large" variant="outlined" @click="goXls">Выгрузить в XLS
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">Название товара</th>
                  <th class="text-center">Вариация товара</th>
                  <th class="text-center bg-indigo-accent-1">Кол-во</th>
                  <th class="text-center">Средняя цена</th>
                  <th class="text-center">Наценка / Скидка</th>
                  <th class="text-center bg-indigo-accent-1">Выручка</th>
                  <th class="text-center bg-indigo-accent-1">Средняя стоимость сделки</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in unicalProduct" :key="item">
                  <tr :class="item.style" class="blue">
                    <td class="text-left">
                      <v-btn class="mx-2" variant="plain" fab small @click="item.menu = true"
                        v-if="item.menu === false && item.items.length > 0">
                        <v-icon dark> mdi-plus </v-icon>
                      </v-btn>
                      <v-btn class="mx-2" variant="plain" fab small @click="item.menu = false"
                        v-if="item.menu === true && item.items.length > 0">
                        <v-icon dark> mdi-minus </v-icon>
                      </v-btn>
                      {{ item.name }}
                    </td>
                    <td class="text-center"></td>
                    <td class="text-center font-weight-bold bg-indigo-accent-1"> {{ item.quantity }}</td>
                    <td class="text-center font-weight-bold">{{ normalNum(item.clearSum / item.quantity) }}</td>
                    <td class="text-center"></td>
                    <td class="text-center font-weight-bold bg-indigo-accent-1"> {{ normalNum(item.clearSum) }}</td>
                    <td class="text-center font-weight-bold bg-indigo-accent-1"> {{ normalNum(item.average_amount) }}
                    </td>
                  </tr>
                  <template v-if="item.menu">
                    <template v-for="group in item.items" :key="group">
                      <tr :class="group.style">
                        <td class="text-right">{{ group.name }}</td>
                        <td class="text-right"> {{ `
                          ${group.property138 ? group.property138 : ''}
                          ${group.property112 ? group.property112 : ''}
                          ${group.property140 ? group.property140 : ''}
                          ${group.property142 ? group.property142 : ''}
                          ${group.property144 ? group.property144 : ''}
                          ${group.property146 ? group.property146 : ''}
                          ${group.property150 ? group.property150 : ''}
                          ${group.property152 ? group.property152 : ''}
                          ${group.property154 ? group.property154 : ''}` }}
                        </td>
                        <td class="text-center"> {{ group.quantity }}</td>
                        <td class="text-center"> {{ (group.sum / group.quantity).toFixed(2) }}</td>
                        <td class="text-center"> {{ group.sum_discont }}</td>
                        <td class="text-center"> {{ group.sum }}</td>
                        <td class="text-center"> {{ }}</td>
                      </tr>
                    </template>
                  </template>
                </template>
                <tr>
                  <th class="text-center font-weight-black"></th>
                  <th class="text-center font-weight-black"> Итого: </th>
                  <th class="text-center font-weight-black"> {{ countProductInDeal }}</th>
                  <th class="text-center font-weight-black"> {{ clearSumFull !== 0 ? normalNum(clearSumFull /
                    countProductInDeal) : 0 }}
                  </th>
                  <th class="text-center font-weight-black"> </th>
                  <th class="text-center font-weight-black"> {{ clearSumFull !== 0 ? normalNum(clearSumFull) : 0 }}</th>
                </tr>
              </tbody>
            </template>
          </v-table>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import 'vue-datepicker-next/locale/ru';
import axios from 'axios';
import exceljs from 'exceljs'
import fileWrite from "file-saver"

export default {
  components: { DatePicker },
  name: 'App',
  data: () => ({
    time0: '',
    selectCategry: [],
    directions: [
      {
        id: 0,
        name: 'Сделки с договорами',
      }
    ],
    category: [
      {
        name: 'Сделки с договорами',
        id: 0
      },
      {
        name: 'Копии и др.',
        id: 6
      },
      {
        name: 'Судебные',
        id: 16
      },
      {
        name: 'Сметы СПб',
        id: 24
      }
    ],
    products: [],
    lenghtProductInConsole: 0,
    priceProductInConsoleL: 0,
    experts: [],
    selectExperts: [],
    deals: [],
    unicalProduct: [],
    getProductInDealArray: [],
    productInCRM: [],
    average_amount: [],
    new_array: [],
    groupedData: [],
    clearSumFull: 0,
    sredSum: 0,
    countProductInDeal: 0,
    sumdeals: 0,
    url: 'https://sudexpert.bitrix24.ru/rest/7748/qpjkefb1bvi1du7d/',
    loading: false,

  }),
  methods: {
    normalNum(number) {
      const formattedNumber = new Intl.NumberFormat('ru-RU', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(number);
      return formattedNumber
    },
    async userGet() {
      const params = {
        order: 'ASC',
        FILTER: {
          UF_DEPARTMENT: 146,
          ACTIVE: true
        }
      }
      const req = await axios.post(this.url + 'user.get', params)
      for (const item of req.data.result) {
        this.experts.push({
          id: item.ID,
          name: `${item.NAME} ${item.LAST_NAME}`
        })
      }
    },
    update() {
      console.log(this.time0)
    },
    async getDeals() {
      const req = await axios.post('https://spa-bitrix.ru/reportProductsSud-expert/getDeals.php',
        {
          data1: this.time0[0],
          data2: this.time0[1],
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      this.deals.push(...req.data)
      console.log(this.deals, 'getDeals')
    },
    async getProductInCRM() {
      const req = await axios.post('https://spa-bitrix.ru/reportProductsSud-expert/getProductInCRM.php')
      this.productInCRM.push(...req.data)
      console.log(this.productInCRM, 'productInCRM')
    },
    async getProductInDeal() {
      const req = await axios.post('https://spa-bitrix.ru/reportProductsSud-expert/getProductForDeal.php',
        {
          data1: this.time0[0],
          data2: this.time0[1],
          selectCategry: this.selectCategry,
          selectExperts: this.selectExperts,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      this.getProductInDealArray.push(...req.data)
      for (const item of this.getProductInDealArray) {
        for (const itemItems of item) {
          this.lenghtProductInConsole += itemItems.QUANTITY
          this.priceProductInConsoleL += itemItems.PRICE * itemItems.QUANTITY
        }
      }
      // console.log(this.getProductInDealArray, 'getProductInDealArray')
      console.log(this.lenghtProductInConsole, 'lenghtProductInConsole')
      console.log(this.priceProductInConsoleL, 'priceProductInConsoleL')
      for (const item of this.getProductInDealArray) {
        if (item) {
          for (const itemProduct of item) {
            if (itemProduct.PRODUCT_NAME !== '') {
              // this.sumdeals += itemProduct.QUANTITY * itemProduct.PRICE
              const searchInCrmProduct = this.products.filter((elem) => elem.id == itemProduct.PRODUCT_ID)[0]
              if (searchInCrmProduct) {

                const pushItem = {
                  dealId: itemProduct.OWNER_ID,
                  sum: itemProduct.QUANTITY * itemProduct.PRICE,
                  ID: searchInCrmProduct.id,
                  name: searchInCrmProduct.name,
                  quantity: itemProduct.QUANTITY,
                  sum_discont: (-(itemProduct.DISCOUNT_SUM ? itemProduct.DISCOUNT_SUM : -0)),
                  price: itemProduct.PRICE,
                  parentId: searchInCrmProduct.parentId ? searchInCrmProduct.parentId.value : '',
                  property138: searchInCrmProduct.property138 ? searchInCrmProduct.property138.valueEnum : '',
                  property112: searchInCrmProduct.property112 ? searchInCrmProduct.property112.valueEnum : '',
                  property140: searchInCrmProduct.property140 ? searchInCrmProduct.property140.valueEnum : '',
                  property142: searchInCrmProduct.property142 ? searchInCrmProduct.property142.valueEnum : '',
                  property144: searchInCrmProduct.property144 ? searchInCrmProduct.property144.valueEnum : '',
                  property146: searchInCrmProduct.property146 ? searchInCrmProduct.property146.valueEnum : '',
                  property150: searchInCrmProduct.property150 ? searchInCrmProduct.property150.valueEnum : '',
                  property152: searchInCrmProduct.property152 ? searchInCrmProduct.property152.valueEnum : '',
                  property154: searchInCrmProduct.property154 ? searchInCrmProduct.property154.valueEnum : '',
                }
                const index = this.unicalProduct.findIndex((elem) => elem.name == itemProduct.PRODUCT_NAME)

                if (index < 0) {
                  if (searchInCrmProduct) {
                    this.unicalProduct.push({
                      average_amount: 0,
                      name: searchInCrmProduct.name,
                      price: 0,
                      clearSum: pushItem.sum,
                      quantity: pushItem.quantity,
                      sredPrice: 0,
                      menu: false,
                      items: [pushItem]
                    })
                  }
                } else {
                  const indexItemsVariation = this.unicalProduct[index].items.findIndex((elem) => elem.ID == pushItem.ID)
                  if (indexItemsVariation > -1) {
                    this.unicalProduct[index].items[indexItemsVariation].quantity += pushItem.quantity
                    this.unicalProduct[index].items[indexItemsVariation].sum += pushItem.sum
                    this.unicalProduct[index].items[indexItemsVariation].sum_discont += pushItem.sum_discont
                    this.unicalProduct[index].clearSum += pushItem.sum
                    this.unicalProduct[index].quantity += pushItem.quantity
                  } else {
                    this.unicalProduct[index].items.push(pushItem)
                    this.unicalProduct[index].clearSum += pushItem.sum
                    this.unicalProduct[index].quantity += pushItem.quantity
                  }
                }
              }
              // console.log(searchInCrmProduct, 'searchInCrmProduct')
            }
          }
        }
      }
      console.log(this.getProductInDealArray, 'getProductInDealArray')
    },
    async pullItems() {
      for (const [index, item] of this.unicalProduct.entries()) {
        for (const indexelem of item.items.keys()) {
          this.unicalProduct[index].items[indexelem].style = 'bg-cyan-lighten-4'
          // console.log(itemsInItem)
          // this.unicalProduct[index].clearSum += itemsInItem.sum
          // this.unicalProduct[index].quantity += itemsInItem.quantity
          this.unicalProduct[index].sredPrice += this.unicalProduct[index].clearSum / this.unicalProduct[index].quantity
        }
        this.sredSum = this.unicalProduct[index].sredPrice
        this.countProductInDeal += this.unicalProduct[index].quantity

        this.clearSumFull += this.unicalProduct[index].clearSum
        this.unicalProduct[index].style = index % 2 ? 'bg-light-blue-lighten-4' : 'bg-light-blue-lighten-5'
      }
      this.unicalProduct.sort(function (a, b) {
        if (a.quantity < b.quantity) {
          return 1;
        }
        if (a.quantity > b.quantity) {
          return -1;
        }
        // a должно быть равным b
        return 0;
      });
      for (const index of this.unicalProduct.keys()) {
        this.unicalProduct[index].style = index % 2 ? 'bg-light-blue-lighten-4' : 'bg-light-blue-lighten-5'
        // console.log(item)
      }
      for (const itemDeal of this.getProductInDealArray) {
        let array = {
          avg: 0,
          name: []
        }
        for (const item of itemDeal) {
          array.avg += item.PRICE * item.QUANTITY
          array.name.push(item.PRODUCT_NAME)
        }
        this.average_amount.push(array)
      }

      console.log(this.average_amount, 'average_amount')
      console.log(this.unicalProduct, 'unicalProduct')
    },
    async groupAndCalculate() {
      const grouped = {};

      this.average_amount.forEach(item => {
        item.name.forEach(name => {
          if (!grouped[name]) {
            grouped[name] = { sum: 0, count: 0, name: name };
          }
          grouped[name].sum += item.avg;
          grouped[name].count++;
        });
      });

      this.groupedData = Object.values(grouped).map(g => ({
        name: g.name,
        avg: Math.round(g.sum / g.count)
      }));
      for (const item of this.groupedData) {
        const search = this.unicalProduct.findIndex((elem) => elem.name == item.name)
        if (search > -1) {
          this.unicalProduct[search].average_amount = item.avg
        }
      }
      console.log(this.groupedData, 'groupedData')
    },
    async getProducts() {
      const req = await axios.post('https://spa-bitrix.ru/reportProductsSud-expert/getProducts.php')
      for (const item of req.data)
        this.products.push(...item)
      console.log(this.products, 'products')
    },
    async goXls() {
      const workbook = new exceljs.Workbook();
      const sheet = workbook.addWorksheet('report');
      sheet.columns = [
        { header: 'Название товара', key: 'name_product', width: 40 },
        { header: 'Вариация товара', key: 'variant_product', width: 40 },
        { header: 'Кол-во', key: 'count_product', width: 15 },
        { header: 'Средняя цена товара', key: 'average_price', width: 20 },
        { header: 'Наценка/Скидка', key: 'markup_discount', width: 20 },
        { header: 'Выручка', key: 'revenue', width: 25 },
        { header: 'Средняя стоимость сделки', key: 'average_cost_dael', width: 25 }
      ]
      let test = []
      for (const item of this.unicalProduct) {
        for (const itemItems of item.items) {
          console.log(itemItems, 'item \\/')
          let test2 = [
            itemItems.name,
            `
              ${itemItems.property138 ? itemItems.property138 : ''}
              ${itemItems.property112 ? itemItems.property112 : ''}
              ${itemItems.property140 ? itemItems.property140 : ''}
              ${itemItems.property142 ? itemItems.property142 : ''}
              ${itemItems.property144 ? itemItems.property144 : ''}
              ${itemItems.property146 ? itemItems.property146 : ''}
              ${itemItems.property150 ? itemItems.property150 : ''}
              ${itemItems.property152 ? itemItems.property152 : ''}
              ${itemItems.property154 ? itemItems.property154 : ''}
           `.trim(),
            itemItems.quantity,
            itemItems.price,
            itemItems.sum_discont,
            itemItems.price * itemItems.quantity,
            itemItems.average_amount
          ]
          console.log(test2, 'Данные для пуша в таблицу')
          test.push(test2)
        }
      }
      sheet.addTable({
        name: 'MyTable',
        ref: 'A1',
        headerRow: true,
        totalsRow: true,
        style: {
          showRowStripes: true,
        },
        columns: [
          { name: 'Название товара', totalsRowLabel: 'Totals:', filterButton: true },
          { name: 'Вариация товара', filterButton: true },
          { name: 'Кол-во', totalsRowFunction: 'sum', filterButton: false },
          { name: 'Средняя цена', totalsRowFunction: 'average', filterButton: false },
          { name: 'Наценка', filterButton: false },
          { name: 'Выручка', totalsRowFunction: 'sum', filterButton: false },
          { name: 'Средняя стоимость сделки', totalsRowFunction: 'sum', filterButton: false },
        ],
        rows: test
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const blob = new Blob([buffer], { type: fileType });
      fileWrite(blob, "report.xlsx");
    },
    async goInvoice() {
      if (!this.time0) {
        alert("Нет даты")
      } else {
        this.loading = true
        this.groupedData = []
        this.average_amount = []
        this.unicalProduct = []
        this.getProductInDealArray = []
        this.clearSumFull = 0
        this.countProductInDeal = 0
        this.sredSum = 0
        // await this.getProductInCRM()
        await this.getDeals()
        await this.getProducts()
        await this.getProductInDeal()
        await this.pullItems()
        await this.groupAndCalculate()
        this.loading = false
      }
    }
  },
  async mounted() {
    await this.userGet()
    // this.selectCategry = this.category
    // this.selectExperts = this.experts
    // this.loading = true
    // await this.getDeals()
    // await this.getProductInDeal()
    // await this.getProducts()
    // await this.pullItems()
    // this.loading = false
  }
}
</script>
